<template>
<div class="Marketing">
   <div class="Marketing_cennert">
      <h2>业务范围</h2>
      <div class="desc">低成本+技术+创意+高端个性定制，全线产品满足您的各种需求</div>
      <ul class="Marketing_scope">
        <div data-aos="fade-up"
            data-aos-duration="1300"> 
          <li>
              <div class="li_img" @click="Jump_point">
                  <div class="li_top">
                      <img src="../../assets/imges/li_top1.png"/>
                  </div>
                  <div class="li_img_bg"></div>
                  <div class="eye">
                      <img src="../../assets/imges/eye.png"/>
                      <p>查看详情</p>
                  </div>
              </div>                      
              <div class="li_footer">
                  <h1>VR展厅漫游</h1>
                  <div class="li_txt">
                      一站式VR展厅漫游体验，人机交互全新体验，如同身临其境，感受高科技模拟现实场景！
                  </div>
              </div>
          </li>
        </div>
            <div data-aos="fade-up"
            data-aos-duration="1300"> 
          <li>
              <div class="li_img" @click="modeling"> 
                  <div class="li_top">
                      <img src="../../assets/imges/li_top2.png"/>
                  </div>
                  <div class="li_img_bg"></div>
                  <div class="eye">
                      <img src="../../assets/imges/eye.png"/>
                      <p>查看详情</p>
                  </div>
              </div>
              <div class="li_footer">
                  <h1>3D产品建模</h1>
                  <div class="li_txt">
                     专业3D团队，工业产品、电器、艺术品逼真720度精度建模，无死角展现产品的匠心细节
                  </div>
              </div>
          </li>
          </div>
              <div data-aos="fade-up"
            data-aos-duration="1300"> 
          <li>
                <div class="li_img" @click="go_shopping">
                  <div class="li_top">
                      <img id="li_top_top" src="../../assets/imges/li_top3_top.png"/>
                      <img src="../../assets/imges/li_top3.png"/>
                  </div>
                  <div class="li_img_bg"></div>
                  <div class="eye">
                      <img src="../../assets/imges/eye.png"/>
                      <p>查看详情</p>
                  </div>
              </div>
              <div class="li_footer">
                  <h1>VR场景购</h1>
                  <div class="li_txt">
                     根据客户需求定制VR购物展厅，让用户体验线上VR实体店购物消费的乐趣！
                  </div>
              </div>
          </li>
          </div>
                <div data-aos="fade-up"
            data-aos-duration="1300"> 
             <li>
                 <div class="li_img" @click="LiveBroadcast">
                  <div class="li_top">
                       <img id="li_top_top1" src="../../assets/imges/li_top4_t.png"/>
                      <img src="../../assets/imges/li_top4.png"/>
                  </div>
                  <div class="li_img_bg"></div>
                  <div class="eye">
                      <img src="../../assets/imges/eye.png"/>
                      <p>查看详情</p>
                  </div>
              </div>
              <div class="li_footer">
                  <h1>展会VR直播</h1>
                  <div class="li_txt">
                      云创5G+VR直播平台，结合最新8K直播VR设备，为您全方位直播展现展汇现场、记录和回顾展会盛况
                  </div>
              </div>
          </li>
          </div>
                <div data-aos="fade-up"
            data-aos-duration="1300"> 
           <li>
                <div class="li_img" @click="houseProperty">
                  <div class="li_top">
                      <img src="../../assets/imges/li_top5.png"/>
                  </div>
                  <div class="li_img_bg"></div>
                  <div class="eye">
                      <img src="../../assets/imges/eye.png"/>
                      <p>查看详情</p>
                  </div>
              </div>
              <div class="li_footer">
                  <h1>房产VR沙盘</h1>
                  <div class="li_txt">
                  数字沙盘高清展现楼盘鸟瞰景观、交通、配套实况，结合VR样板间无缝行走漫游，开展全方位移动房产营销
                  </div>
              </div>
          </li>
          </div>
               <div data-aos="fade-up"
            data-aos-duration="1300"> 
             <li>
                 <div class="li_img" @click="IndustrialSystem">
                  <div class="li_top">
               
                      <img src="../../assets/imges/li_top6.png"/>
                  </div>
                  <div class="li_img_bg"></div>
                  <div class="eye">
                      <img src="../../assets/imges/eye.png"/>
                      <p>查看详情</p>
                  </div>
              </div>
              <div class="li_footer">
                  <h1>5G工业数据监控</h1>
                  <div class="li_txt">
                      采集并对接IOT数据，建设数字孪生工厂，三维仿真还原现场，智能化动态展示监控！
                  </div>
              </div>
            </li>
       </div>
      </ul>
   </div>
   <div class="Marketing_bg"></div>
</div>
</template>
<script>
export default {
    data() {
        return {
            //bg的索引
            img:0
        }
    },
    methods:{
        Jump_point(){
            this.$router.push({
                path: `/cases`,
                query: {
                     goid: 'cal'
                }
            })
        },
        modeling(){
            this.$router.push({
                path: `/cases`,
                query: {
                     goid: 'modeling'
                }
            })
        },
        go_shopping(){
            const cloud = document.querySelector('.cloud')
            document.documentElement.scrollTop = cloud.offsetTop - 60
        },
        LiveBroadcast(){
            this.$router.push({
                path: `/cases`,
                query: {
                     goid: 'LiveBroad'
                }
            })
        },
        houseProperty(){
            this.$router.push({
                path: `/cases`,
                query: {
                     goid: 'houseProperty'
                }
            })
        },
        IndustrialSystem(){
            this.$router.push({
                path: `/modeling`,
                query: {
                     goid: 'modeling'
                }
            })
        }
    }
}
</script>
<style scoped>
.Marketing{
    width: 100%;
    height: 1343px;
    background: #142443;
    position: relative;
}
.Marketing_bg{
    width: 100%;
    height: 100%;
    background: url("../../assets/imges/Marketing_bg.jpg") no-repeat ;
    background-size: 100% 100%;
    opacity: 0.2;
    position: absolute;
    left: 0;
    top: 0;
}
.Marketing_cennert{
    width: 1202px;
    height: 1175px;
    margin: 0px auto;
    z-index: 9;
    position: relative;
}

.Marketing h2{
    padding-top: 63px;
    text-align: center;
    font-weight: 400;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
}
.Marketing .desc{
    padding-top: 12px;
    padding-bottom: 60px;
    font-size: 18px;
    color: #d3dddc;
    text-align: center;
}
.Marketing_scope{
    height: 1034px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content:space-between;
    z-index: 9;
}
.Marketing_scope li{
    width: 380px;
    height: 500px;
    background: #fff;
    margin-bottom: 33px;
  
}
.Marketing_scope li .li_img .li_top{
    width: 100%;
    height: 320px;
    /* background:turquoise; */
}
.Marketing_scope li .li_img .li_top img{
    width: 100%;
    /* height: 100%; */
}
.li_footer{
    height: 148px;
    padding: 33px 30px 0px 32px;
}
.li_footer h1{
    font-size: 20px;
    margin-bottom: 15px;
}
.li_txt {
    font-size: 15px;
    color: #6b6b6b;
}
.li_img{
    position: relative;
    cursor: pointer;
}
.li_img:hover .li_img_bg{
    opacity: 1;
}
.li_img:hover .eye{
    opacity: 1;
}
.li_img_bg{
    width: 100%;
    height: 320px;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(25,25,25,.5);
    opacity: 0;
    transition: 0.5s all;
}
.eye{
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    transform: translate(-50%,-50%);
    opacity: 0;
    text-align: center;
}
.eye p{
    margin-top: 1px;
    font-size: 12px;
    color: #fff;
}
#li_top_top{
    position: absolute;
    left: 193px;
    bottom: -68px;
    width: 242px;
    /* height: 332px; */
}
#li_top_top1{
    position: absolute;
    right: 24px;
    bottom: -15px;
    width: 88px;
    height: 137px;
}
</style>


// WEBPACK FOOTER //
// src/common/index/page-marketing.vue